import { formatCurrency } from "src/shared/hooks/formatCurrency"

interface MesajeInfoProps {
    deletedArray: string[]
    newSubcategoryList: string[]
    subCategorias: any[]
    resEdit: {
        limite: string | undefined
        gasto: string | undefined
    }
    dataAnterior: {
        gasto: string
        limiteA: string
    }
}

export const MesajeEdit = ({
    resEdit,
    dataAnterior,
    deletedArray,
    subCategorias,
    newSubcategoryList,
}: MesajeInfoProps) => {
    let subEdited: any[] = []

    if (deletedArray.length === 1) {
        subEdited = subCategorias.filter(
            (subcategoria) =>
                subcategoria.subcategoria_gasto_id === deletedArray[0]
        )
    }

    const hasGasto = !!resEdit?.gasto && resEdit.gasto !== ""
    const hasLimite = !!resEdit?.limite && resEdit.limite !== ""
    const hasDeleted = deletedArray.length > 0
    const hasNewSubcategories = newSubcategoryList.length > 0

    const onlyNewSubcategories =
        hasNewSubcategories && !hasGasto && !hasLimite && !hasDeleted

    const newSubcategoryLabel = (withAnd: boolean) => {
        if (!hasNewSubcategories) return null

        const count = newSubcategoryList.length
        const text = `${count} subcategoría${count > 1 ? "s" : ""}`

        return (
            <>
                {withAnd ? " y " : ""}
                <span>
                    {withAnd ? `se agregará${count > 1 ? "n" : ""} ` : `Se agregará${count > 1 ? "n" : ""} `}
                </span>
                <span className="mesajesEdit__text-bold">{text}</span>
                {"."}
            </>
        )
    }

    return (
        <>
            {/* SOLO nuevas subcategorías */}
            {onlyNewSubcategories && (
                <div className="mesajesEdit">
                    <div className="mesajesEdit__text">
                        {newSubcategoryLabel(false)}
                    </div>
                </div>
            )}

            {/* NOMBRE */}
            {hasGasto && !hasLimite && !hasDeleted && (
                <div className="mesajesEdit">
                    <div className="mesajesEdit__text">
                        <span>El nombre de la categoría </span>
                        <span className="mesajesEdit__text-bold">
                            &quot;{dataAnterior.gasto}&quot;{" "}
                        </span>
                        <span>se editará a </span>
                        <span className="mesajesEdit__text-bold">
                            &quot;{resEdit.gasto}&quot;
                        </span>
                        {"."}
                        {newSubcategoryLabel(true)}
                    </div>
                </div>
            )}

            {/* LÍMITE */}
            {hasLimite && !hasGasto && !hasDeleted && (
                <div className="mesajesEdit">
                    <div className="mesajesEdit__text">
                        {Number(dataAnterior.limiteA) === 0 ? (
                            <>
                                <span>Se agregó el límite mensual de gasto por </span>
                                <span className="mesajesEdit__text-bold">
                                    {formatCurrency(Number(resEdit.limite))}
                                </span>
                            </>
                        ) : (
                            <>
                                <span>Se editará el límite mensual de gastos de </span>
                                <span className="mesajesEdit__text-bold">
                                    {formatCurrency(Number(dataAnterior.limiteA))} a{" "}
                                    {formatCurrency(Number(resEdit.limite))}
                                </span>
                            </>
                        )}
                        {"."}
                        {newSubcategoryLabel(true)}
                    </div>
                </div>
            )}

            {/* NOMBRE + LÍMITE */}
            {hasGasto && hasLimite && !hasDeleted && (
                <div className="mesajesEdit">
                    <div className="mesajesEdit__text">
                        <span>El nombre de la categoría </span>
                        <span className="mesajesEdit__text-bold">
                            &quot;{dataAnterior.gasto}&quot;{" "}
                        </span>
                        <span>se editará a </span>
                        <span className="mesajesEdit__text-bold">
                            &quot;{resEdit.gasto}&quot;
                        </span>
                        {" y "}
                        <span>se editará el límite mensual de gastos de </span>
                        <span className="mesajesEdit__text-bold">
                            {formatCurrency(Number(dataAnterior.limiteA))} a{" "}
                            {formatCurrency(Number(resEdit.limite))}
                        </span>
                        {"."}
                        {newSubcategoryLabel(true)}
                    </div>
                </div>
            )}

            {/* ELIMINAR SUBCATEGORÍAS */}
            {hasDeleted && !hasGasto && !hasLimite && (
                <div className="mesajesEdit">
                    <div className="mesajesEdit__text">
                        {deletedArray.length === 1 ? (
                            <>
                                <span>Se eliminará la subcategoría </span>
                                <span className="mesajesEdit__text-bold">
                                    &quot;{subEdited[0]?.subcategoria}&quot;
                                </span>
                            </>
                        ) : (
                            <>
                                <span>Se eliminarán </span>
                                <span className="mesajesEdit__text-bold">
                                    {deletedArray.length}
                                </span>
                                <span> subcategorías</span>
                            </>
                        )}
                        {"."}
                        {newSubcategoryLabel(true)}
                    </div>
                </div>
            )}

            {/* NOMBRE + ELIMINAR */}
            {hasGasto && hasDeleted && !hasLimite && (
                <div className="mesajesEdit">
                    <div className="mesajesEdit__text">
                        <span>El nombre de la categoría </span>
                        <span className="mesajesEdit__text-bold">
                            &quot;{dataAnterior.gasto}&quot;{" "}
                        </span>
                        <span>se editará a </span>
                        <span className="mesajesEdit__text-bold">
                            &quot;{resEdit.gasto}&quot;
                        </span>
                        {" y "}
                        {deletedArray.length === 1 ? (
                            <>
                                <span>se eliminará la subcategoría </span>
                                <span className="mesajesEdit__text-bold">
                                    &quot;{subEdited[0]?.subcategoria}&quot;
                                </span>
                            </>
                        ) : (
                            <>
                                <span>se eliminarán </span>
                                <span className="mesajesEdit__text-bold">
                                    {deletedArray.length}
                                </span>
                                <span> subcategorías</span>
                            </>
                        )}
                        {"."}
                        {newSubcategoryLabel(true)}
                    </div>
                </div>
            )}

            {/* LÍMITE + ELIMINAR */}
            {hasLimite && hasDeleted && !hasGasto && (
                <div className="mesajesEdit">
                    <div className="mesajesEdit__text">
                        {Number(dataAnterior.limiteA) === 0 ? (
                            <>
                                <span>Se agregó el límite mensual de gasto por </span>
                                <span className="mesajesEdit__text-bold">
                                    {formatCurrency(Number(resEdit.limite))}
                                </span>
                            </>
                        ) : (
                            <>
                                <span>Se editará el límite mensual de gastos de </span>
                                <span className="mesajesEdit__text-bold">
                                    {formatCurrency(Number(dataAnterior.limiteA))} a{" "}
                                    {formatCurrency(Number(resEdit.limite))}
                                </span>
                            </>
                        )}
                        {" y "}
                        {deletedArray.length === 1 ? (
                            <>
                                <span>se eliminará la subcategoría </span>
                                <span className="mesajesEdit__text-bold">
                                    &quot;{subEdited[0]?.subcategoria}&quot;
                                </span>
                            </>
                        ) : (
                            <>
                                <span>se eliminarán </span>
                                <span className="mesajesEdit__text-bold">
                                    {deletedArray.length}
                                </span>
                                <span> subcategorías</span>
                            </>
                        )}
                        {"."}
                        {newSubcategoryLabel(true)}
                    </div>
                </div>
            )}
        </>
    )
}